module.exports = __webpack_public_path__ + "9e9df77cc3f9071abe4ed6df1d7e48ca.svg";